import Cookies from 'universal-cookie'


export function setCookie(cookieName: any, value: any, expDate?: Date) {
    const cookies = new Cookies();
    if (expDate)
        cookies.set(cookieName, value, {expires: expDate})
    else
        cookies.set(cookieName, value)
}